export const ORG_BILDTVAPP = "BILDTVAPP";
export const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  id: "default",
  theme: "default",
};

export type BrandSettings = {
  id: string;
  theme: string;
  xHandle?: string;
};

export type Organization = BrandSettings & {
  categories?: BrandSettings[];
};

export const organizations: Organization[] = [
  {
    id: "WELT",
    theme: "welt",
    xHandle: "welt",
    categories: [{ id: "icon", theme: "icon", xHandle: "ICONISTbyicon" }],
  },
  { id: "BILD", theme: "bild", xHandle: "bild" },
  {
    id: "BILD-BOOKS",
    theme: "default",
    categories: [
      {
        id: "travelbook",
        theme: "bild_travelbook",
        xHandle: "travelbook_de",
      },
      {
        id: "fitbook",
        theme: "bild_fitbook",
        xHandle: "fitbook_de",
      },
      {
        id: "stylebook",
        theme: "bild_stylebook",
        xHandle: "stylebook_de",
      },
      {
        id: "techbook",
        theme: "bild_techbook",
        xHandle: "techbook",
      },
      {
        id: "myhomebook",
        theme: "bild_myhomebook",
        xHandle: "myhomebook_de",
      },
    ],
  },
  { id: "AUBI", theme: "aubi", xHandle: "autobild" },
  { id: "COBI", theme: "cobi", xHandle: "COMPUTERBILD" },
  { id: "SPOBI", theme: "spobi", xHandle: "SPORTBILD" },
  { id: "BZ", theme: "bild", xHandle: "bz" },
  {
    id: "BRANDSTUDIO",
    theme: "default",
    categories: [
      {
        id: "bild-brand",
        theme: "bild_brandstory",
        xHandle: "bild",
      },
      {
        id: "bild-product-advertorial",
        theme: "bild_productstory",
        xHandle: "bild",
      },
      {
        id: "books-travelbook-brand",
        theme: "bild_travelbook",
        xHandle: "travelbook_de",
      },
      {
        id: "books-fitbook-brand",
        theme: "bild_fitbook",
        xHandle: "fitbook_de",
      },
      {
        id: "books-stylebook-brand",
        theme: "bild_stylebook",
        xHandle: "stylebook_de",
      },
      {
        id: "books-techbook-brand",
        theme: "bild_techbook",
        xHandle: "techbook",
      },
      {
        id: "books-myHomebook-brand",
        theme: "bild_myhomebook",
        xHandle: "myhomebook_de",
      },
      {
        id: "welt-brand",
        theme: "welt_brandstory",
        xHandle: "welt",
      },
      {
        id: "welt-product-advertorial",
        theme: "welt_productstory",
        xHandle: "welt",
      },
      {
        id: "manschaftsbus",
        theme: "manschaftsbus",
      },
    ],
  },
  {
    id: "MEDIAPIONEER",
    theme: "mediapioneer",
    xHandle: "mediapioneercom",
  },
  {
    id: "MUSIKEXPRESS",
    theme: "musikexpress",
    xHandle: "musikexpressde",
  },
  { id: ORG_BILDTVAPP, theme: "bild", xHandle: "bild" },
  {
    id: "ROLLINGSTONE",
    theme: "rollingstone",
    xHandle: "rollingstoneDE",
  },
  {
    id: "METALHAMMER",
    theme: "metalhammer",
    xHandle: "metalhammer_de",
  },
];

export const getBrand = (
  organizationId: string,
  categoryId?: string
): BrandSettings => {
  const organization = organizations.find(
    (organization: Organization) =>
      organization.id === organizationId.toUpperCase()
  );

  if (organization && categoryId) {
    const category = organization.categories?.find(
      (category: BrandSettings) => category.id === categoryId.toLowerCase()
    );
    return category ?? organization;
  }

  return organization ?? DEFAULT_BRAND_SETTINGS;
};
